export default __webpack_public_path__ + "static/media/modelY.d2d74cd2.png";